import React from "react"
import styled from "@emotion/styled"
import { Box, Container, Flex } from "theme-ui"
import { Link } from "gatsby"

const Wrapper = styled.div`
    height: 36.5%;
    padding: 2rem;
    background-image: linear-gradient(
        to right,
        #f4e2ff 0%,
        #f4e2ff 3%,
        #e4befb 3%,
        #e4befb 6%,
        #894bb8 6%,
        #894bb8 9%,
        #510291 9%,
        #510291 91%,
        #894bb8 91%,
        #894bb8 94%,
        #e4befb 94%,
        #e4befb 97%,
        #f4e2ff 97%,
        #f4e2ff 100%
    );

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 2rem 1rem;
    }

    & > div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`
const TitleBox = styled.div`
    text-align: center;
    margin: 1rem;
    & h2,
    p,
    a {
        color: ${(props) => props.theme.colors.background};
    }

    & a {
        background: ${(props) => props.theme.colors.green};
        padding: 0.5rem 1.75rem;
        text-transform: uppercase;
    }
`

const WhiteBox = styled.div`
    background: ${(props) => props.theme.colors.background};
    padding: 0.5rem;
    width: 90%;
    z-index: 15;
    margin-top: -5rem;
    box-shadow: 0px 24px 40px #00000029;
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        width: 100%;
        margin-top: -3rem;
    }
    & > div {
        background: #f9f9f9;
        text-align: center;
        padding: 2rem;
    }
`
const IconWrapper = styled(Flex)`
    justify-content: space-between;
    flex-wrap: wrap;
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        justify-content: center;
    }
`

const IconBox = styled(Box)`
    box-shadow: 0px 0px 10px #0000001f;
    border-radius: 2rem;
    display: flex;
    flex-direction: column;
    width: 150px;
    height: 150px;
    padding: 1rem;
    margin-bottom: 1rem;
    align-items: center;
    & img {
        height: 64px;
        width: 64px;
    }
    & p {
        text-align: center;
        margin-top: auto;
        font-size: 0.825rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        margin: 1rem;
    }
`

const Index = (data) => {
    return (
        <Wrapper>
            <Container className="container">
                <WhiteBox>
                    <Box>
                        <p>
                            Having optimal mental and physical health is
                            equivalent to a successful and rewarding life.
                        </p>
                        <p>
                            Wellness, however, does not happen by chance. One
                            needs to make a conscious choice and effort to
                            think, eat and live well — daily. There may also be
                            undesirable factors hindering us from achieving our
                            wellness goals. And some of these challenges are
                            beyond our ability to control or manage.
                        </p>
                        <p>
                            <strong>Dynamics Wellness Centre</strong> recognises
                            the importance of extending a helping hand and
                            lending a listening ear during such moments. We
                            empower individuals to overcome their challenges and
                            thrive physically and mentally through our inclusive
                            and holistic solutions.
                        </p>
                        <IconWrapper>
                            <IconBox>
                                <img src="/icons/icon-counselling-and-psychotherapy.svg" />
                                <p>Counselling & Psychotherapy</p>
                            </IconBox>
                            <IconBox>
                                <img src="/icons/icon-speech-therapy-for-adults.svg" />
                                <p>Speech Therapy for Adults</p>
                            </IconBox>
                            <IconBox>
                                <img src="/icons/icon-physiotherapy-for-adults.svg" />
                                <p>Physiotherapy for Adults</p>
                            </IconBox>
                            <IconBox>
                                <img src="/icons/icon-nutrition.svg" />
                                <p>Nutrition</p>
                            </IconBox>
                            <IconBox>
                                <img src="/icons/icon-keto-coaching.svg" />
                                <p>Keto Coaching</p>
                            </IconBox>
                        </IconWrapper>
                    </Box>
                </WhiteBox>
                <TitleBox>
                    <h2>Your Wellness Journey Begins Here</h2>
                    <p>
                        Prioritise YOURSELF, take your wellness journey with us
                        today.
                    </p>
                    <Link to="/contact">Let`s get started</Link>
                </TitleBox>
            </Container>
        </Wrapper>
    )
}

export default Index
